import { render } from "./Pomodoro.vue?vue&type=template&id=1c0b38f5&scoped=true"
import script from "./Pomodoro.vue?vue&type=script&lang=js"
export * from "./Pomodoro.vue?vue&type=script&lang=js"

import "./Pomodoro.vue?vue&type=style&index=0&id=1c0b38f5&scoped=true&lang=css"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0b38f5"]])

export default __exports__